/**
 * Legacy module — preserved as an empty module so existing dependencies
 * (`acme.common.service.membership.offering`) keep resolving.
 *
 * The real implementation lives at:
 *   apps/b2b-frontend/app/core/membership/offering/offering.service.ts
 *
 * It's registered with AngularJS in
 *   apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 * via downgradeInjectable, so any `$inject = ['MembershipOfferingService']`
 * resolves to the Angular 18 class. Wave 3 item #28.
 */
angular.module('acme.common.service.membership.offering', [
  'acme.common.service.api',
  'acme.common.service.membership',
]);
